import { render, staticRenderFns } from "./JdsPanel.vue?vue&type=template&id=5a67a884&scoped=true&"
import script from "./JdsPanel.vue?vue&type=script&lang=ts&"
export * from "./JdsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67a884",
  null
  
)

export default component.exports